import { Injectable, inject } from '@angular/core';
import {CryptoService} from '@app/core/services/crypto.service';
import {PlatformStorage} from '../tokens/platform-storage.token';

@Injectable({
  providedIn: 'root',
})
export class LocalStorageService extends PlatformStorage {
  private readonly cryptoService = inject(CryptoService);


  public override key(index: number): string | null {
    return localStorage.key(index);
  }

  public override getItem<T>(key: string): T | null {
    const value = localStorage.getItem(key);

    if (value) {
      return JSON.parse(this.cryptoService.decrypt(value));
    }

    return null;
  }

  public override setItem<T>(key: string, value: T): void {
    if (value) {
      localStorage.setItem(key, this.cryptoService.encrypt(JSON.stringify(value)));
    }
  }

  public override removeItem(key: string) {
    localStorage.removeItem(key);
  }

  public override clear() {
    localStorage.clear();
  }
}
